/* eslint-disable @typescript-eslint/no-explicit-any */
export type ClassValue = ClassArray | ClassDictionary | string | number | null | boolean | undefined;
export type ClassDictionary = Record<string, any>;
export type ClassArray = ClassValue[];

function toVal(mix: ClassValue): string {
  let y: string;
  let str = '';

  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (typeof mix === 'object') {
    if (Array.isArray(mix)) {
      const len = mix.length;
      for (let k = 0; k < len; k++) {
        if (mix[k]) {
          if ((y = toVal(mix[k]))) {
            if (str.length > 0) str += ' ';
            str += y;
          }
        }
      }
    } else {
      for (y in mix as ClassDictionary) {
        if ((mix as ClassDictionary)[y]) {
          if (str.length > 0) str += ' ';
          str += y;
        }
      }
    }
  }

  return str;
}

/**
 * A tiny utility for constructing `className` strings conditionally.
 *
 * Note: This implementation is copied directly from the `clsx` library by Luke Edwards.
 *
 * @see https://github.com/lukeed/clsx
 * @param inputs - A variable number of class values (strings, objects, arrays, etc.).
 * @returns A single string of joined class names.
 */
export function clsx(...inputs: ClassValue[]): string {
  let tmp: ClassValue;
  let x: string;
  let str = '';
  const len = inputs.length;

  for (let i = 0; i < len; i++) {
    if ((tmp = inputs[i])) {
      if ((x = toVal(tmp))) {
        if (str.length > 0) str += ' ';
        str += x;
      }
    }
  }
  return str;
}
